import styled from 'styled-components';

import { AlertCircleOutlineIc } from '@dsch/dd-icons';

import { LinkButton } from 'components/Toolkit/Button/LinkButton';
import { Text } from 'components/ToolkitV2/Text/Text';

import { Spacer } from 'helpers/genericStyles';
import { theme } from 'helpers/Theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

type NetworkErrorProps = {
  onClick: () => void;
};

const NetworkError = (props: NetworkErrorProps) => {
  const { onClick } = props;

  return (
    <Container>
      <AlertCircleOutlineIc width={40} height={40} color={theme.colors.GREY} />
      <Spacer marginBottom="M16" />
      <Text forwardedAs="h2" size="L18">
        Something went wrong
      </Text>
      <Spacer marginBottom="S4" />
      <Text align="center" size="M16">
        There was a problem processing your
        <br />
        request - please click&nbsp;
        <LinkButton inline onClick={onClick}>
          reload
        </LinkButton>
        &nbsp;to try again.
      </Text>
    </Container>
  );
};

export { NetworkError };
